import React from 'react';
import cn from 'clsx';
import { DownloadSimpleIcon } from '@fronton/icons-react';
import { Typography } from 'fronton-react';
import { DownloadCatalogCart } from '../gallery-catalog';
import {
  kitchenDownloadCatalogBody,
  kitchenDownloadCatalogIcon,
  kitchenDownloadCatalogImage,
  kitchenDownloadCatalogText,
  newKitchenDownloadCatalogCartImage,
  newDownloadCatalogCartBody,
  newDownloadCatalogCartText,
} from './kitchen-download-catalog-styles';

type KitchenDownloadCatalogProps = {
  elementBlock: string;
  elementText: string;
  isNewKitchen?: boolean;
};

export const KitchenDownloadCatalog: React.FC<KitchenDownloadCatalogProps> = ({
  elementBlock,
  elementText,
  isNewKitchen,
}) => (
  <DownloadCatalogCart
    elementBlock={elementBlock}
    elementName={elementText}
    elementText="Скачать каталог кухонь"
    catalogHref="https://storage.yandexcloud.net/leroymerlin-ru-landings-docs/kitchen/Catalog-Delinia-ID.pdf"
    linkTitle="Скачать каталог кухонь">
    <div className={cn(kitchenDownloadCatalogBody, { [newDownloadCatalogCartBody]: isNewKitchen })}>
      <DownloadSimpleIcon
        className={kitchenDownloadCatalogIcon}
        type="outline"
        size="l"
        color={isNewKitchen ? 'text-minor' : 'text-primary'}
      />
      <Typography
        className={cn(kitchenDownloadCatalogText, { [newDownloadCatalogCartText]: isNewKitchen })}
        variant="l"
        size="body_accent">
        Скачать каталог кухонь
      </Typography>
    </div>
    {isNewKitchen ? (
      <img
        alt="Изображение каталога кухонь"
        className={newKitchenDownloadCatalogCartImage}
        src="https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/new-kitchen/gallery/catalog-icon.png/catalog-icon.png"
      />
    ) : (
      <img
        alt="Изображение каталога кухонь"
        className={kitchenDownloadCatalogImage}
        src="https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/kitchen/gallery/catalog-icon.png/catalog-icon.png"
      />
    )}
  </DownloadCatalogCart>
);
